import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getDopingsByUserTypeId } from "./Services";



export const useGetGeneralDopings= (userTypeId:number) => {
  return useQuery(
    [endpoints.getDopingsByUserTypeId,userTypeId],
    () => getDopingsByUserTypeId(userTypeId),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};



